<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="30%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="类型" prop="type">
        <el-select v-model="formData.type" placeholder="请选择" @change="getMediaCategoryList">
          <el-option label="音频" :value="1"></el-option>
          <el-option label="视频" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="名称" prop="title">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item label="媒体分类" prop="media_categroy_id">
        <el-select v-model="formData.media_categroy_id" placeholder="请选择媒体分类" filterable clearable>
          <el-option label="请选择媒体分类" :value="0"></el-option>
          <el-option v-for="item in mediaCategoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="图片" prop="pic">
        <template>
          <el-upload
            class="avatar-uploader"
            action="/proxy/upload_img222"
            name="img"
            :show-file-list="false"
            :before-upload="handleImageUpload">
            <img v-if="picUrl" :src="picUrl+'?imageView2/0/w/50'" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </template>
      </el-form-item>
      <el-form-item label="音频/视频" prop="path">
        <el-upload
          name="media"
          :show-file-list="false"
          action="/proxy/upload_media222"
          :before-upload="handleMediaUpload">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <el-progress v-if="uploading" :percentage="upPercent"></el-progress>
        <el-input v-model="formData.path"></el-input>
      </el-form-item>
      <el-form-item label="简介" prop="intro">
        <el-input v-model="formData.intro" type="textarea" :rows="3"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as qiniu from 'qiniu-js'
import md5 from 'js-md5'
export default {
  name: 'media_add',
  props: [
    'visible', 'id'
  ],
  data () {
    return {
      title: '添加音视频',
      uploadPrepareResp: {},
      formData: {
        title: '',
        pic: '',
        path: '',
        intro: '',
        type: 1,
        media_categroy_id: 0
      },
      mediaCategoryList: [],
      picUrl: '',
      uploading: 0,
      upPercent: 0,
      addFormRules: {
        title: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        media_categroy_id: [
          { required: true, message: '请选择媒体分类', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.picUrl = ''
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑音视频'
        this.getInfo(this.id)
      } else {
        this.title = '添加音视频'
        this.getMediaCategoryList()
      }
      this.uplodPrepare()
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/media/info/' + id)
      if (res.code === 0) {
        this.formData = {
          title: res.data.title,
          pic: res.data.pic,
          path: res.data.path,
          intro: res.data.intro,
          type: res.data.type || 1,
          media_categroy_id: res.data.media_categroy_id || 0
        }
        this.picUrl = res.data.pic_url
        this.getMediaCategoryList()
      }
    },
    async getMediaCategoryList () {
      const res = await this.$http.get('/admin/media_category/select_list', { type_id: this.formData.type })
      if (res.code === 0) {
        this.mediaCategoryList = res.data || []
      }
    },
    async uplodPrepare (fileName) {
      const res = await this.$http.get('/admin/upload_prepare')
      if (res.code === 0) {
        this.uploadPrepareResp = res.data
      }
    },
    async QnDelete (fileName) {
      const res = await this.$http.post('/admin/qn_delete', { file_name: fileName })
      if (res.code === 0) {
        return true
      } else {
        return false
      }
    },
    async QnRefreshCdn (fileName) {
      const res = await this.$http.post('/admin/qn_refresh_cdn', { file_name: fileName })
      if (res.code === 0) {
        return true
      } else {
        return false
      }
    },
    handleMediaUpload (file) {
      this.upPercent = 0
      this.uploading = 0
      const fileNameArr = file.name.split('.')
      const key = 'media/' + this.getDateString() + '/' + md5(file.name + this.getDateString()) + '.' + fileNameArr[1]
      this.QnDelete(key)
      const putExtra = { fname: key }
      const config = { useCdnDomain: true, region: qiniu.region.z0 } // 根据需要选择区域
      const observable = qiniu.upload(file, key, this.uploadPrepareResp.up_token, putExtra, config)
      this.uploading = 1
      const next = (res) => {
        // 可以在这里添加上传进度条更新的代码
        this.upPercent = Math.ceil(res.total.percent)
      }
      const error = (err) => {
        this.$message.error(err.message)
      }
      const complete = (res) => {
        // 上传完成后的处理逻辑
        this.upPercent = 100
        this.uploading = 0
        this.formData.path = res.key
        this.QnRefreshCdn(key)
      }
      observable.subscribe({ next, error, complete })
      return false
    },
    handleImageUpload (file, uploadType) {
      this.upPercent = 0
      this.uploading = 0
      const fileNameArr = file.name.split('.')
      const key = 'image/' + this.getDateString() + '/' + md5(file.name + Date.now()) + '.' + fileNameArr[1]
      const putExtra = { fname: key }
      const config = { useCdnDomain: true, region: qiniu.region.z0 } // 根据需要选择区域
      const observable = qiniu.upload(file, key, this.uploadPrepareResp.up_token, putExtra, config)
      this.uploading = 1
      const next = (res) => {
        // 可以在这里添加上传进度条更新的代码
        this.upPercent = Math.ceil(res.total.percent)
      }
      const error = (err) => {
        this.$message.error(err.message)
      }
      const complete = (res) => {
        // 上传完成后的处理逻辑
        this.upPercent = 100
        this.uploading = 0
        this.formData.pic = res.key
        this.picUrl = this.uploadPrepareResp.res_domain + res.key
      }
      observable.subscribe({ next, error, complete })
      return false
    },
    getDateString () {
      const date = new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}${month}${day}`
    }
  }
}
</script>

<style>
</style>
